import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import { dataControlStore } from '@stores/dataControlStore';

import styles from './Breadcrumbs.module.scss';

interface IBreadcrumbs {
  className?: string;
  withoutAction?: boolean;
}

export const Breadcrumbs = observer(({ className, withoutAction }: IBreadcrumbs) => {
  const { pagesParam, removePage, breadcrumbs, removeBreadcrumb } = dataControlStore;

  const onClick = useCallback(
    (index) => {
      const count = breadcrumbs.length - index;

      if (count < pagesParam.length) {
        removePage(false, count);
        removeBreadcrumb(count);
      }
    },
    [breadcrumbs.length, pagesParam.length, removeBreadcrumb, removePage],
  );

  const onBack = useCallback(() => {
    removePage();
    removeBreadcrumb();
  }, [removeBreadcrumb, removePage]);

  if (!breadcrumbs.length) return null;

  return (
    <div className={cm(styles.breadcrumbs, className)}>
      <div className={styles.breadcrumb}>
        {breadcrumbs.map((value, index) => {
          const isLink = breadcrumbs.length - index < pagesParam.length;

          return (
            <div
              key={value}
              onClick={() => onClick(index)}
              className={cm({
                [styles.link]: isLink,
              })}
            >
              {value}
            </div>
          );
        })}
      </div>

      {!withoutAction && (
        <div className={styles.buttons}>
          {pagesParam.length > 1 && (
            <div onClick={onBack}>
              <Icon name="cancelArrow" />
            </div>
          )}
        </div>
      )}
    </div>
  );
});
